// frontend/src/components/athleteEditor/SealButton.jsx
import React from 'react';

// state: 'verified' (filled seal) | 'unverified' (outline ghost) | 'none' (nothing).
// Clicking toggles verification via onToggle. Rendered absolutely inside a
// .ae-field__control by the caller (className passthrough), or inline elsewhere.
export default function SealButton({ state, title, onToggle, disabled = false, className = 'ae-field__seal' }) {
  if (state === 'none') return null;
  const ghost = state === 'unverified';
  return (
    <button
      type="button"
      className={`${className}${ghost ? ' ae-field__seal--ghost' : ''}`}
      title={title}
      aria-label={ghost ? 'Not verified — click to verify' : 'Verified — click to unverify'}
      disabled={disabled}
      onClick={disabled ? undefined : onToggle}
    >
      {ghost ? <OutlineSeal /> : <FilledSeal />}
    </button>
  );
}

// Outline variant of the checkmark.seal path (VerifiedFlame filled version).
function OutlineSeal() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
      <path d="M12 1.5l2.09 2.09 2.91-.75 1.07 2.84 2.84 1.07-.75 2.91L22.5 12l-2.34 2.34.75 2.91-2.84 1.07-1.07 2.84-2.91-.75L12 22.5l-2.09-2.09-2.91.75-1.07-2.84-2.84-1.07.75-2.91L1.5 12l2.34-2.34-.75-2.91 2.84-1.07 1.07-2.84 2.91.75z" stroke="#6B7C8E" strokeWidth="1.6" fill="none"/>
      <path d="M8.5 12.5l2.2 2.2 4.8-5" stroke="#6B7C8E" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

// Filled variant (mirrors VerifiedFlame's brand paths) — no title/aria of its
// own, so the caller's title/aria-label is the sole tooltip + a11y label.
function FilledSeal() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style={{ verticalAlign: 'middle' }}>
      <path d="M12 1.5l2.09 2.09 2.91-.75 1.07 2.84 2.84 1.07-.75 2.91L22.5 12l-2.34 2.34.75 2.91-2.84 1.07-1.07 2.84-2.91-.75L12 22.5l-2.09-2.09-2.91.75-1.07-2.84-2.84-1.07.75-2.91L1.5 12l2.34-2.34-.75-2.91 2.84-1.07 1.07-2.84 2.91.75z" fill="#007AFF"/>
      <path d="M8.5 12.5l2.2 2.2 4.8-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
